export default "__VITE_ASSET__DIXEm8Gl__"